module.exports = __webpack_public_path__ + "static/amulet_of_proof_against_detection_and_location-d82d586f59697223d80304b166631ac3.jpeg";